import { styled, css } from "styled-components";

const Window = styled.div`
  background-color: var(--window-background);
  border-color: var(--window-border);
  border-style: var(--border-style);
  border-width: var(--border-width);
  
  ${(props) => props.$padding && css`
    padding: var(--space-3);
  `}
`;

export default Window;